import { render, staticRenderFns } from "./QuizMultipleChoiceSelectForm.vue?vue&type=template&id=51ebe6ee&"
import script from "./QuizMultipleChoiceSelectForm.vue?vue&type=script&lang=ts&"
export * from "./QuizMultipleChoiceSelectForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports